import { render, staticRenderFns } from "./licitacoesList.vue?vue&type=template&id=8085c082&scoped=true"
import script from "./licitacoesList.ts?vue&type=script&lang=ts&external"
export * from "./licitacoesList.ts?vue&type=script&lang=ts&external"
import style0 from "./licitacoesList.vue?vue&type=style&index=0&id=8085c082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8085c082",
  null
  
)

export default component.exports